module.exports = __webpack_public_path__ + "img/introduce-icon3.305b2bb9.png";